import {Slot} from '@yandex-delivery/blocks'

import {classes} from './SlotDivider.classes'

export function SlotDivider() {
  return <Slot className={classes.root} />
}
